import { lazy } from 'react';

// Lazy loading para páginas públicas
export const Landing = lazy(() => import('../pages/publics/Landing'));
export const Login = lazy(() => import('../pages/publics/Login'));
export const Register = lazy(() => import('../pages/publics/Register'));
export const ForgotPassword = lazy(() => import('../pages/publics/ForgotPassword'));
export const ResetPassword = lazy(() => import('../pages/publics/ResetPassword'));
export const VerifyEmail = lazy(() => import('../pages/publics/VerifyEmail'));
export const ActivateAccount = lazy(() => import('../pages/publics/ActivateAccount'));
export const SubscribeCheckout = lazy(() => import('../pages/publics/SubscribeCheckout'));
export const ChoosePlan = lazy(() => import('../pages/publics/ChoosePlan'));
export const SelectPlan = lazy(() => import('../pages/publics/SelectPlan'));

// Lazy loading para páginas privadas
export const MyAccount = lazy(() => import('../pages/privates/MyAccount'));

// Lazy loading para Dashboard
/** Home do cliente (`/` e `/dashboard/summary`) e admin — SummaryV2. */
export const SummaryDashboard = lazy(() => import('../pages/privates/Dashboard/SummaryV2'));
export const AdminDashboardHome = lazy(
  () => import('../pages/privates/Dashboard/AdminDashboardHome')
);
export const FuelsIndicatorsDashboard = lazy(
  () => import('../pages/privates/Dashboard/FuelsIndicators')
);
export const FuelsIndicatorsEthanolDashboard = lazy(
  () => import('../pages/privates/Dashboard/FuelsIndicatorsEthanol')
);
export const FuelsIndicatorsBiodieselDashboard = lazy(
  () => import('../pages/privates/Dashboard/FuelsIndicatorsBiodiesel')
);
export const FuelsIndicatorsPetroleumDerivativesDashboard = lazy(
  () => import('../pages/privates/Dashboard/FuelsIndicatorsPetroleumDerivatives')
);
export const CustomerQuotesDashboard = lazy(
  () => import('../pages/privates/Dashboard/CustomerQuotes')
);
export const MyStationDashboard = lazy(() => import('../pages/privates/Dashboard/MyStation'));
export const ConsultantDashboard = lazy(() => import('../pages/privates/Consultant/Dashboard'));

// Lazy loading para Configurações
export const Users = lazy(() => import('../pages/privates/Configurations/Users/index'));
export const CategoryCustomers = lazy(
  () => import('../pages/privates/Configurations/CategoryCustomers')
);
export const UnitOfMeasurement = lazy(
  () => import('../pages/privates/Configurations/UnitOfMeasurement')
);
export const BrandANP = lazy(() => import('../pages/privates/Configurations/BrandsANP'));
export const ProductANP = lazy(() => import('../pages/privates/Configurations/ProductANP'));
export const Municipalities = lazy(() => import('../pages/privates/Configurations/Municipalities'));
export const Regions = lazy(() => import('../pages/privates/Configurations/Regions'));
export const AnpValuesImport = lazy(
  () => import('../pages/privates/Configurations/AnpValuesImport')
);
export const PdfLayouts = lazy(() => import('../pages/privates/Configurations/PdfLayouts'));
export const HtmlReportTemplates = lazy(
  () => import('../pages/privates/Configurations/HtmlReportTemplates')
);
export const IntegrationCredentials = lazy(
  () => import('../pages/privates/Configurations/IntegrationCredentials')
);

// Lazy loading para Registrations
export const People = lazy(() => import('../pages/privates/Registrations/People'));
export const Consultants = lazy(() => import('../pages/privates/Registrations/Consultants'));
export const Customers = lazy(() => import('../pages/privates/Registrations/Customers'));
export const CustomerDetailPage = lazy(
  () => import('../pages/privates/Registrations/Customers/CustomerDetailPage')
);
export const CustomerNewPage = lazy(
  () => import('../pages/privates/Registrations/Customers/CustomerNewPage')
);
export const CustomersEngagementPage = lazy(
  () => import('../pages/privates/Registrations/Customers/CustomersEngagementPage')
);
export const DistributorsFuel = lazy(
  () => import('../pages/privates/Registrations/FuelDistributors')
);
export const FuelOperationalBases = lazy(
  () => import('../pages/privates/Registrations/FuelOperationalBases')
);
export const BaseDetailPage = lazy(
  () => import('../pages/privates/Registrations/FuelOperationalBases/BaseDetailPage')
);
export const BaseNewPage = lazy(
  () => import('../pages/privates/Registrations/FuelOperationalBases/BaseNewPage')
);
export const ConsultantDetailPage = lazy(
  () => import('../pages/privates/Registrations/Consultants/ConsultantDetailPage')
);
export const ConsultantNewPage = lazy(
  () => import('../pages/privates/Registrations/Consultants/ConsultantNewPage')
);
export const DistributorDetailPage = lazy(
  () => import('../pages/privates/Registrations/FuelDistributors/DistributorDetailPage')
);
export const DistributorNewPage = lazy(
  () => import('../pages/privates/Registrations/FuelDistributors/DistributorNewPage')
);
export const PersonDetailPage = lazy(
  () => import('../pages/privates/Registrations/People/PersonDetailPage')
);
export const PersonNewPage = lazy(
  () => import('../pages/privates/Registrations/People/PersonNewPage')
);
export const SubscriptionPlans = lazy(
  () => import('../pages/privates/Registrations/SubscriptionPlans')
);
export const PlanDetailPage = lazy(
  () => import('../pages/privates/Registrations/SubscriptionPlans/PlanDetailPage')
);
export const PlanNewPage = lazy(
  () => import('../pages/privates/Registrations/SubscriptionPlans/PlanNewPage')
);

// Lazy loading para Quotes
export const QuotesFuelDistributors = lazy(() => import('../pages/privates/Quotes/Distributors'));
export const QuotesCustomersEconomy = lazy(() => import('../pages/privates/Quotes/Economy'));
export const PriceComparison = lazy(() => import('../pages/privates/Quotes/priceComparison'));
export const PriceComparisonStep = lazy(
  () => import('../pages/privates/Quotes/priceComparison/stepANewComparison')
);
export const PriceComparisonNew = lazy(
  () => import('../pages/privates/Quotes/priceComparison/stepBNewComparison')
);
export const PriceComparisonShow = lazy(
  () => import('../pages/privates/Quotes/priceComparison/stepDShowComparison')
);
export const PriceComparisonHistoryDetail = lazy(
  () => import('../pages/privates/Quotes/priceComparison/historyDetail')
);

// Lazy loading para Indicators
export const FuelOilRefineries = lazy(
  () => import('../pages/privates/Indicators/FuelOilRefineries')
);
export const FuelOilRefineriesOperatorPole = lazy(
  () => import('../pages/privates/Indicators/FuelOilRefineriesOperatorPole')
);
export const FuelProductLinesDerivations = lazy(
  () => import('../pages/privates/Indicators/FuelProductLinesDerivations')
);
export const FuelsIndicatorsBiodiesel = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsBiodiesel')
);
export const FuelsIndicatorsEthanol = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsEthanol')
);
export const FuelsIndicatorsPetroleumDerivatives = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsPetroleumDerivatives')
);
export const FuelMarketSummaries = lazy(
  () => import('../pages/privates/Indicators/FuelMarketSummaries')
);
export const FuelsIndicatorsCategories = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsCategories')
);
export const FuelsIndicatorsCatalog = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsCatalog')
);
export const MarketIndicatorProposals = lazy(
  () => import('../pages/privates/Indicators/MarketIndicatorProposals')
);
export const FuelsIndicatorsMarket = lazy(
  () => import('../pages/privates/Indicators/FuelsIndicatorsMarket')
);
export const MyStationFlagsAdmin = lazy(() => import('../pages/privates/Admin/MyStationFlags'));

// Lazy loading para Notifications
export const Notifications = lazy(() => import('../pages/privates/Notifications'));

// Lazy loading — Chat
export const ChatWhatsApp = lazy(() => import('../pages/privates/Chat/WhatsApp'));
